import React, { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import { AboutSection } from '../components/home/AboutSection';
import { RosterSection } from '../components/home/RosterSection';
import { InstagramSection } from '../components/home/InstagramSection';
import { ContactSection } from '../components/home/ContactSection';
import { JoinMovementSection } from '../components/home/JoinMovementSection';
import { useContent } from '../context/ContentContext';
import { usePageMeta } from '../hooks/usePageMeta';

const toFeaturedArtist = (artist, tag, pagePath, topTrack, testId) => ({
  name: artist.name,
  genre: artist.genre,
  image: artist.image,
  bio: artist.bio,
  tag,
  pagePath,
  topTrack,
  testId
});

const buildFeaturedArtists = (element45, lilD, yellowZoo) => {
  const artists = [];
  if (element45?.releases?.length) {
    artists.push(toFeaturedArtist(element45, 'Element 45', '/element45/olah-bliss', element45.releases[0], 'olah-bliss'));
  }
  if (lilD?.tracks?.length) {
    artists.push(toFeaturedArtist(lilD, 'New Signing', '/artists#lil-d', lilD.tracks[0], 'lil-d'));
  }
  if (yellowZoo?.tracks?.length) {
    artists.push(toFeaturedArtist(yellowZoo, 'New Signing', '/artists#yellow-zoo', yellowZoo.tracks[0], 'yellow-zoo'));
  }
  return artists;
};

export default function Home({ setCurrentTrack }) {
  usePageMeta(
    'Rhodium Records | Rare by Nature, Relentless by Design',
    'Rhodium Records - An independent record label championing boundary-pushing artists. Home of Òlah Bliss, Lets Get It Boy Lil D, and Yellow Zoo.'
  );
  const { element45, roster } = useContent();
  const lilD = roster.find((a) => a.slug === 'lil-d');
  const yellowZoo = roster.find((a) => a.slug === 'yellow-zoo');

  const featuredArtists = buildFeaturedArtists(element45, lilD, yellowZoo);

  const playTopTrack = (artist) => {
    setCurrentTrack({
      title: artist.topTrack.title,
      artist: artist.name,
      artwork: artist.image,
      spotifyUrl: artist.topTrack.spotifyUrl
    });
  };

  // Set Òlah Bliss - Radio as default track once content loads
  useEffect(() => {
    if (!element45 || !setCurrentTrack) return;
    const radioTrack = (element45.releases || []).find((release) => release.title === 'Radio');
    if (radioTrack) {
      setCurrentTrack({
        title: radioTrack.title,
        artist: element45.name,
        artwork: element45.image,
        spotifyUrl: radioTrack.spotifyUrl
      });
    }
  }, [element45, setCurrentTrack]);

  return (
    <div className="bg-black">
      <AboutSection />
      <HeroSection />
      <RosterSection artists={featuredArtists} onPlay={playTopTrack} />
      <InstagramSection />
      <ContactSection />
      <JoinMovementSection />
    </div>
  );
}
